<section class="details-historie-card" [attr.data-testid]="testId()">
  <to-section-title [title]="title() || ('common.detailsHistorie.titel' | translate)" [subtitle]="subtitle()">
    <ng-container ngProjectAs="[right]"><ng-content select="[detailsHistorieAktionen]" /></ng-container>
  </to-section-title>
  @if (tabs().length) {
    <div
      class="details-historie-card__reiter"
      role="tablist"
      [attr.aria-label]="'common.detailsHistorie.reiterLabel' | translate"
    >
      @for (tab of tabs(); track tab.id; let i = $index) {
        @let aktiv = tab.id === aktiveId();
        <button
          #reiterButton
          type="button"
          role="tab"
          class="details-historie-card__tab"
          [class.details-historie-card__tab--aktiv]="aktiv"
          [id]="tabId(tab.id)"
          [attr.data-testid]="tabId(tab.id)"
          [attr.aria-selected]="aktiv"
          [attr.aria-controls]="aktiv ? panelId(tab.id) : null"
          [attr.tabindex]="aktiv ? 0 : -1"
          (click)="waehle(tab.id)"
          (keydown)="onKeydown($event, i)"
        >
          <span class="details-historie-card__label">{{ tab.label }}</span>
          @if (tab.count) {
            <span class="details-historie-card__badge" aria-hidden="true">{{ tab.count }}</span>
            <span class="sr-only">
              {{
                (tab.count === 1 ? 'common.detailsHistorie.eintraegeOne' : 'common.detailsHistorie.eintraegeOther')
                  | translate: { n: tab.count }
              }}
            </span>
          }
        </button>
      }
    </div>
    <div
      class="details-historie-card__panel"
      role="tabpanel"
      [id]="panelId(aktiveId())"
      [attr.aria-labelledby]="tabId(aktiveId())"
    >
      <ng-container [ngTemplateOutlet]="aktivesPanel()" />
    </div>
  }
</section>
